// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-relative[data-v-491b2998]{position:relative}.btn-cancel[data-v-491b2998]{bottom:32px;position:absolute;right:32px}.v-icon-back[data-v-491b2998]{color:rgba(0,0,0,.54);font-size:30px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
